<template>

  <ur-modal ref="modal" title="중복 일정 캠페인" :width="464" :height="494">
    <div class="cam_schedule_pop">      
      <div class="modal_body">
        <div class="total">
          총 <strong>{{scheduleTotalCount}}</strong>
        </div>
        <div class="overlap_list">
          <dl v-for="item in scheduleItems" v-bind:key="item.scheduleId">
            <dt>{{item.scheduleName}}</dt>
            <dd>{{item.startDate}} ~ {{item.endDate}} ({{item.startTimeLimit}} ~ {{item.endTimeLimit}})<br>{{item.calleeCount}}건 등록</dd>
          </dl>
        </div>
      </div>
    </div>
    <template slot="action">
      <ur-button @click="close" main>확인</ur-button>
    </template>
  </ur-modal>

</template>

<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_AIC_00003_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  components: {
    BasePage,
  }, 
  props: {
    onCloseOngoingPopup: {
      type: Function,
      default: () => {},
    },
    ongoingSchedules: { 
      type: Array, 
      default: () => [] 
    },
  },
  data() {
    return {
      scheduleItems : [],
      scheduleTotalCount : 0,
    };
  },
 
  computed: {

  },
 
  watch: {

  },
 
  created() {

  },

  mounted() {
    // console.log(this.ongoingSchedules)
    
  },
 
  beforeUpdate() {

  },
 
  updated() {

  },
 
  beforeDestroy() {

  },
 
  destroyed() {
    
  },
 
  methods: {
    open(){
      this.init();
      this.$refs['modal'].open();
    },
    close(){
      this.$refs['modal'].close();
    },
    init(){
      this.scheduleTotalCount = this.ongoingSchedules.length;
      this.scheduleItems = [];

      for (var schedule of this.ongoingSchedules) {
        let row = {};
        row.scheduleName = schedule.scheduleName;
        row.startDate = schedule.startDate.substr(0, 4) + '-' + schedule.startDate.substr(4, 2) + '-' + schedule.startDate.substr(6, 2);
        row.endDate = schedule.endDate.substr(0, 4) + '-' + schedule.endDate.substr(4, 2) + '-' + schedule.endDate.substr(6, 2);
        row.startTimeLimit = schedule.startTimeLimit.substr(0, 2) + ':' + schedule.startTimeLimit.substr(2, 2);
        row.endTimeLimit = schedule.endTimeLimit.substr(0, 2) + ':' + schedule.endTimeLimit.substr(2, 2);
        row.calleeCount = utils.numberWithCommas(schedule.calleeCount);
        this.scheduleItems.push(row);
      }
    },
  },
};
</script>

<style scoped>
.cam_schedule_pop .modal_header {margin-bottom:24px;}
.cam_schedule_pop .modal_body {height:332px;max-height:332px;overflow:unset;padding-right:0px}
.cam_schedule_pop .total {margin-bottom:16px}
.cam_schedule_pop .overlap_list {max-height:290px; overflow-y: auto;}
.cam_schedule_pop .overlap_list dl:not(:first-child) {margin-top:18px}
.cam_schedule_pop .overlap_list dl dt {font-size:16px; color:#333; font-weight: 500;line-height: 24px;}
.cam_schedule_pop .overlap_list dl dd {font-size:16px; color:#5a5a5a;line-height: 24px; margin-top:4px}
</style>